import React from "react";
import {
    CASH_ITEM_TRANSACTION_TYPE_LABELS,
    TransactionType,
} from "@common/types/transaction";

interface Props {
    filters: {
        transactionTypes?: TransactionType[];
    };
}

const CASH_ITEM_TRANSACTION_TYPE_LABEL_BY_TYPE: Partial<
    Record<TransactionType, string>
> = CASH_ITEM_TRANSACTION_TYPE_LABELS;

export const CashItemTypeFilterLabel: React.FC<Props> = ({
    filters: { transactionTypes },
}) => {
    if (!transactionTypes?.length) {
        return null;
    }

    const [firstLabel, ...restLabels] = transactionTypes.map(
        (type) => CASH_ITEM_TRANSACTION_TYPE_LABEL_BY_TYPE[type] ?? type,
    );

    return (
        <>
            {[
                firstLabel,
                ...restLabels.map((label) => label.toLowerCase()),
            ].join(" or ")}
        </>
    );
};
